import React from 'react';
import { connect } from 'react-redux';
import ProjectsPC from '../projects/projects.pc';
import { trackPage } from '../../util/analytics';

class AppList extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        trackPage('/list');
    }

    render() {
        return (<ProjectsPC />);
    }
}

const mapStateToProps = state => ({
    account: state.account,
    intlr: state.intlr
});

export default connect(
    mapStateToProps
)(AppList);